import type { SessionStepModule } from '../types';
import { EmailStepDetail } from './EmailStepDetail';
import { EmailStepRunner } from './EmailStepRunner';
import { isEmailVerificationStep } from './email.utils';

// Email Verification step — WE email a code and the applicant types it back, proving they control
// the mailbox. The third module that calls no provider (Document Template, then Questionnaire), and
// the first that sends something of its own.
export const emailStepModule: SessionStepModule = {
  key: 'email_verification',
  matches: isEmailVerificationStep,
  Runner: EmailStepRunner,
  Detail: EmailStepDetail,
};
